export default __webpack_public_path__ + "457bac4b2fee60691f571076d56a6d9a.png";